import PropTypes from 'prop-types';
import equals from "ramda/es/equals";
import cx from "ramda-extension/es/cx";
import noop from "ramda-extension/es/noop";
import valueMirror from "ramda-extension/es/valueMirror";
import React from 'react';
import AngleLeft from '../../../atoms/SvgIcon/Icons/AngleLeft';
import AngleRight from '../../../atoms/SvgIcon/Icons/AngleRight';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
const COMPONENT_NAME = 'HorizontalScrollButton';
const positions = [
    'left',
    'right'
];
export const buttonPositions = valueMirror(positions);
const equalsLeft = equals(buttonPositions.left);
const HorizontalScrollButton = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { leftIcon = /*#__PURE__*/ React.createElement(AngleLeft, null), rightIcon = /*#__PURE__*/ React.createElement(AngleRight, null), position, handleClick, visible, disabled, ...other } = props;
    const icon = equalsLeft(position) ? rightIcon : leftIcon;
    return /*#__PURE__*/ React.createElement("span", {
        onClick: disabled ? noop : handleClick,
        className: cx('HorizontalScroll-arrowIcon', {
            'Utils--hidden': !visible
        }),
        ...other
    }, icon);
};
HorizontalScrollButton.propTypes = {
    /**
	 * Whether button is disabled and therefore ignores onClick events
	 */ disabled: PropTypes.bool,
    /**
	 * Function handler to handle onClick events
	 */ handleClick: PropTypes.func,
    /**
	 * Left icon node
	 */ leftIcon: PropTypes.node,
    /**
	 * Button position, on of two possible position `left` or `right`
	 */ position: PropTypes.oneOf(positions),
    /**
	 * Right icon node
	 */ rightIcon: PropTypes.node,
    /**
	 * Whether to hide button via css or not
	 */ visible: PropTypes.bool
};
export default HorizontalScrollButton;
